<template>
  <g
    :transform="(flip === true ? `scale(-.7 .7) translate(-${x/.7} ${y/.7 + 42}) rotate(-90)`: `scale(.7 .7) translate(${x/.7} ${y/.7 + 42}) rotate(-90)`)"
    stroke="white"
  >
    <!-- <rect x="0" y="0" width="28" height="35" fill="white"/>
    <path fill="#e0e0e0" d="M42.4454.5a4,4,0,0,0-4,4v24h8V4.5A4,4,0,0,0,42.4454.5Z"/>
    <rect :fill="color" x="32.4454" y="75.5" width="20" height="3"/>
    <rect :fill="color" x="27.4454" y="37.5" width="30" height="17"/>
    <rect :fill="color" x="27.4454" y="71.5" width="30" height="4"/>
    <rect :fill="color" x="32.4454" y="28.5" width="20" height="5"/>
    <path
      :fill="color"
      d="M25.4454,35.5a2.0059,2.0059,0,0,1,2-2h30a2.0059,2.0059,0,0,1,2,2h0a2.0059,2.0059,0,0,1-2,2h-30a2.0059,2.0059,0,0,1-2-2Z"
    />
    <path
      :fill="color"
      d="M25.4454,35.5a2.0059,2.0059,0,0,1,2-2h30a2.0059,2.0059,0,0,1,2,2h0a2.0059,2.0059,0,0,1-2,2h-30a2.0059,2.0059,0,0,1-2-2Z"
    />
    <rect :fill="color" x="27.4454" y="49.5" width="4" height="22"/>
    <rect :fill="color" x="25.4454" y="54.5" width="34" height="17"/>
    <g class="cls-5">
      <line :fill="color" x1="24.3536" y1="41.9081" x2="62.5373" y2="80.0919"/>
      <line :fill="color" x1="30.3536" y1="41.9081" x2="68.5373" y2="80.0919"/>
      <line :fill="color" x1="36.3536" y1="41.9081" x2="74.5373" y2="80.0919"/>
      <line :fill="color" x1="42.3536" y1="41.9081" x2="80.5373" y2="80.0919"/>
      <line :fill="color" x1="18.3536" y1="41.9081" x2="56.5373" y2="80.0919"/>
      <line :fill="color" x1="12.3536" y1="41.9081" x2="50.5373" y2="80.0919"/>
      <line :fill="color" x1="6.3536" y1="41.9081" x2="44.5373" y2="80.0919"/>
      <line :fill="color" x1="0.3536" y1="41.9081" x2="38.5373" y2="80.0919"/>
    </g>
    <path
      :fill="color"
      d="M57.4454,37.5H53.0421L42.32,42.5a3.6273,3.6273,0,0,0-3.3749-3,3.7863,3.7863,0,0,0-3.5,4v4a3.7863,3.7863,0,0,0,3.5,4c.0213,0,.0411-.0068.0622-.0072l4.854.0072,13.5838-6.3342Z"
    /> -->
    <g 
      :fill="color">
      <path
          d="m 42.4454,0.5 a 4,4 0 0 0 -4,4 v 24 h 8 v -24 a 4,4 0 0 0 -4,-4 z"
          id="path836" />
        <rect
          x="32.4454"
          y="75.5"
          width="20"
          height="3"
          id="rect838" />
        <rect
          x="27.4454"
          y="37.5"
          width="30"
          height="17"
          id="rect840"
            />
        <rect
          x="27.4454"
          y="71.5"
          width="30"
          height="4"
          id="rect842"
          />
        <rect
          x="32.4454"
          y="28.5"
          width="20"
          height="5"
          id="rect844"
          />
        <path
          d="m 25.4454,35.5 a 2.0059,2.0059 0 0 1 2,-2 h 30 a 2.0059,2.0059 0 0 1 2,2 v 0 a 2.0059,2.0059 0 0 1 -2,2 h -30 a 2.0059,2.0059 0 0 1 -2,-2 z"
          id="path846"
          />
        <path
          d="m 25.4454,35.5 a 2.0059,2.0059 0 0 1 2,-2 h 30 a 2.0059,2.0059 0 0 1 2,2 v 0 a 2.0059,2.0059 0 0 1 -2,2 h -30 a 2.0059,2.0059 0 0 1 -2,-2 z"
          id="path848"
          />
        <rect
          x="27.4454"
          y="49.5"
          width="4"
          height="22"
          id="rect850" />
        <rect
          x="25.4454"
          y="54.5"
          width="34"
          height="17"
          id="rect852"
          />
        <g
          fill="white"
          clip-path="inset(0% 25% 0% 25%)"
          id="g870">

          <line
            x1="24.3536"
            y1="41.9081"
            x2="62.5373"
            y2="80.091904"
            id="line854"
            />
          <line
            x1="30.3536"
            y1="41.9081"
            x2="68.5373"
            y2="80.091904"
            id="line856"
            />
          <line
            x1="36.3536"
            y1="41.9081"
            x2="74.5373"
            y2="80.091904"
            id="line858"
            />
          <line
            x1="42.3536"
            y1="41.9081"
            x2="80.5373"
            y2="80.091904"
            id="line860"
            />
          <line
            x1="18.3536"
            y1="41.9081"
            x2="56.5373"
            y2="80.091904"
            id="line862"
            />
          <line
            x1="12.3536"
            y1="41.9081"
            x2="50.5373"
            y2="80.091904"
            id="line864"
            />
          <line
            x1="6.3536"
            y1="41.9081"
            x2="44.5373"
            y2="80.091904"
            id="line866"
            />
          <line
            x1="0.3536"
            y1="41.9081"
            x2="38.5373"
            y2="80.091904"
            id="line868"
            />
        </g>
        <path
          d="m 57.4454,37.5 h -4.4033 l -10.7221,5 a 3.6273,3.6273 0 0 0 -3.3749,-3 3.7863,3.7863 0 0 0 -3.5,4 v 4 a 3.7863,3.7863 0 0 0 3.5,4 c 0.0213,0 0.0411,-0.0068 0.0622,-0.0072 l 4.854,0.0072 13.5838,-6.3342 z"
          id="path872"
          />
    </g>
  </g>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    plugColor: String,
    x: Number,
    y: Number,
    flip: Boolean
  },
  data() {
    return {
      plugWidth: 25,
      plugHeight: 10
    };
  },
  computed: {
    ...mapGetters([
      'getCssColor'
    ]),
    color: function() {
      return this.getColor(this.plugColor);
    },
    yRecalculated: function() {
      return this.y - this.plugHeight / 2;
    }
  },
  methods: {
    getColor(colorName) {
      return this.getCssColor(colorName);
    },
    getNoseColor: colorName => {
      return this.getCssColor(colorName + "Nase");
    }
  }
};
</script>